import React, { useCallback } from 'react';
import { Checkbox } from '@gafe/common-ui';

import { useOrderContext } from '@/components/modals/SubmitOrder/helpers';

import { Props } from './types';

import styles from './LegalInformation.module.scss';

export const LegalInformation = ({ isChecked, onToggle }: Props) => {
  const state = useOrderContext();
  const toggle = useCallback(() => onToggle(!isChecked), [onToggle, isChecked]);

  return (
    <>
      <div className={styles.message_wrapper} data-testid="legal-information-wrapper">
        {state.isAccessProgram ? (
          <p>
            GAF Energy reserves the right to independently verify that each installation is in
            compliance with our specifications, including the requirements described above. Such
            requirements are deemed to be incorporated into each project&apos;s scope of work
            Failure to comply with GAF Energy&apos;s specifications may result in project delays.
            Notwithstanding any terms to the contrary in your subcontract agreement with GAF Energy,
            GAF Energy may withhold payments to you until a non-complying installation is corrected.
          </p>
        ) : (
          <p>
            GAF Energy reserves the right to independently verify that each installation is in
            compliance with our specifications, including the requirements described above. Failure
            to comply with GAF Energy&apos;s specifications may result in project delays and
            inability to activate systems, and GAF Energy may withhold electrical installation
            services until a non-complying installation is corrected.
          </p>
        )}
      </div>

      <Checkbox
        checked={isChecked}
        label="I have reviewed and agree with the roof requirements for Timberline Solar installations."
        onClick={toggle}
      />
    </>
  );
};
